import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react"

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

type Props = {
  items: BreadcrumbItem[];
  /** Sur fond sombre (hero) */
  onDark?: boolean;
  className?: string;
};

export const ModernBreadcrumb: React.FC<Props> = ({ items, onDark = false, className = "" }) => {
  if (!items.length) return null;

  return (
    <nav
      className={`modern-breadcrumb${onDark ? " modern-breadcrumb--on-dark" : ""} ${className}`.trim()}
      aria-label="Fil d'Ariane"
    >
      <ol className="modern-breadcrumb__list">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="modern-breadcrumb__item">
              {i > 0 && <span className="modern-breadcrumb__sep" aria-hidden="true"> <ChevronRight size={16} style={{ marginRight: 1, marginLeft: 3 }} /> </span>}
              {isLast || !item.href ? (
                <span className="modern-breadcrumb__current" aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.href} className="modern-breadcrumb__link">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
